import { render, staticRenderFns } from "./Organizational_Development.vue?vue&type=template&id=5f95d6d2&scoped=true&"
import script from "./Organizational_Development.vue?vue&type=script&lang=js&"
export * from "./Organizational_Development.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f95d6d2",
  null
  
)

export default component.exports